import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const token = localStorage.getItem('token');
    const usuario = localStorage.getItem('usuarioSistema');
    const expectedUsuario = route.data['expectedUsuario'];
    const redirectTo = route.data['redirectTo'] ?? '/';

    if (token && usuario === expectedUsuario && this.isTokenValido(token)) {
      return true;
    }

    return this.router.parseUrl(redirectTo);
  }

  private isTokenValido(token: string): boolean {
    try {
      const payloadBase64 = token.split('.')[1];
      const payloadJson = atob(payloadBase64);
      const payload = JSON.parse(payloadJson);

      if (!payload.exp) return false;

      const expiracion = payload.exp * 1000;
      return Date.now() < expiracion;
    } catch (err) {
      console.warn('Token inválido:', err);
      return false;
    }
  }
}
